var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGrayFolder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.418 1.059C6.923.945 5.404.976 3.394 1.117c-1.253.088-2.228 1.072-2.368 2.288C.443 8.481.246 13.603.86 18.735c.256 2.149 2.01 3.669 4.042 3.89 4.799.522 9.528.509 14.324-.013a4.443 4.443 0 0 0 3.921-3.877c.38-3.174.479-6.421.245-10.387a4.125 4.125 0 0 0-3.777-3.87c-2.038-.168-3.541-.199-5.763-.243l-1.029-.021a.854.854 0 0 1-.782-.558l-.344-.927a2.556 2.556 0 0 0-2.278-1.67Z",
  fill: "#3A434A"
})));
export default SvgGrayFolder;